import React, { useEffect, useState } from 'react';
import DatePicker, {
  CalendarContainer as CustomCalendar,
  registerLocale,
} from 'react-datepicker';
import { FiCalendar } from 'react-icons/fi';

import { ptBR } from 'date-fns/locale';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

import {
  Container,
  CalendarContainer,
  SideBar,
  SideBarOption,
  InputContainer,
} from './styles';

interface CalendarProps {
  getRange: (range: Date[]) => void;
  isValidRange: (isValid: boolean) => void;
  useContainer?: boolean;
}

interface CustomInputProps {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Calendar: React.FC<CalendarProps> = ({
  getRange,
  isValidRange,
  useContainer,
}) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [range, setRange] = useState<Date[]>([]);
  const [activeOption, setActiveOption] = useState('');

  const handleDateRange = (dates: Date[], option: string) => {
    setStartDate(null);
    setEndDate(null);
    setActiveOption(option);
    setRange(dates);
    getRange(dates);
  };

  registerLocale('pt-BR', ptBR);
  moment.locale('pt-BR');

  const getFormatedRange = () => {
    if (range.length) {
      const formatedRange = range.map((date) =>
        moment(date).format('DD/MM/YY'),
      );
      return `${formatedRange[0]} - ${formatedRange[1]}`;
    }
    return '';
  };

  const CustomInput = (
    { onClick }: CustomInputProps,
    ref: React.Ref<HTMLButtonElement>,
  ) => (
    <InputContainer type="button" onClick={onClick} ref={ref}>
      <input
        disabled
        placeholder="DD/MM/AA - DD/MM/AA"
        value={getFormatedRange()}
      />
      <FiCalendar size={17} color="#eb0045" />
    </InputContainer>
  );

  const CustomCalendarContainer: React.FC = ({ children }) => (
    <CalendarContainer>
      <CustomCalendar>
        <div style={{ position: 'relative' }}>{children}</div>
      </CustomCalendar>
      {useContainer && (
        <SideBar>
          <SideBarOption
            isActive={activeOption === 'currentMonth'}
            onClick={() =>
              handleDateRange(
                [
                  new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                  new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() + 1,
                    0,
                  ),
                ],
                'currentMonth',
              )
            }
            type="button"
          >
            Mês atual
          </SideBarOption>
          <SideBarOption
            isActive={activeOption === 'previousMonth'}
            onClick={() =>
              handleDateRange(
                [
                  new Date(
                    new Date().getFullYear(),
                    new Date().getMonth() - 1,
                    1,
                  ),
                  new Date(new Date().getFullYear(), new Date().getMonth(), 0),
                ],
                'previousMonth',
              )
            }
            type="button"
          >
            Mês passado
          </SideBarOption>
          <SideBarOption
            isActive={activeOption === 'currentYear'}
            onClick={() =>
              handleDateRange(
                [
                  new Date(new Date().getFullYear(), 0, 1),
                  new Date(new Date().getFullYear(), 11, 31),
                ],
                'currentYear',
              )
            }
            type="button"
          >
            Esse ano
          </SideBarOption>
        </SideBar>
      )}
    </CalendarContainer>
  );

  const onChange = (dates: any) => {
    const [start, end] = dates;
    setActiveOption('');
    setStartDate(start);
    setEndDate(end);
    if (start && end) {
      setRange(dates);
      getRange(dates);
    }
  };

  useEffect(() => {
    if (range.length) {
      isValidRange(true);
    } else {
      isValidRange(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range]);

  return (
    <Container>
      <DatePicker
        startDate={startDate}
        endDate={endDate}
        onChange={onChange}
        selectsRange
        formatWeekDay={(nameOfDay) => nameOfDay.substr(0, 0)}
        calendarContainer={CustomCalendarContainer}
        locale={ptBR}
        customInput={React.createElement(React.forwardRef(CustomInput))}
      />
    </Container>
  );
};

export default Calendar;
